import { render } from "./MobileHeader.vue?vue&type=template&id=5ecc4291"
import script from "./MobileHeader.vue?vue&type=script&lang=js"
export * from "./MobileHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maxime/Documents/Projects/Ombrage/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__